import { createSelector } from 'reselect';
import getFutureOrderingLimitGeneric from './getFutureOrderingLimitGeneric';

import getOrdering from './getOrdering';

export default createSelector(
  [getOrdering, getFutureOrderingLimitGeneric],
  (ordering, futureOrderingLimitGenericFallback): number => {
    const { futureOrderingEnableCateringDelivery } = ordering.config;

    if (!futureOrderingEnableCateringDelivery) {
      return 1;
    }

    /**
     * If futureOrderingEnableCateringDelivery is disabled it should
     * return 1 else the user wont be able to order catering, this
     * should never return 0 to avoid that scenario.
     *
     * This logic was previously in all of the future ordering selectors
     * on web and mobile, and its now here for consistency.
     */

    return (
      ordering.config.futureOrderingLimitCateringDelivery ||
      futureOrderingLimitGenericFallback ||
      1
    );
  },
);
